import Button from '@/common/components/Button'
import SelectController from '@/common/components/SelectController'
import { Mapper } from '@/common/services/mapper'
import CreateForwardingDirectiveEntryFormStepAccordion from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/components/CreateForwardingDirectiveEntryFormStepAccordion'
import { MaintenanceForwardingsDirectiveFromSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { useMaintenanceDirectiveDiagnosticEntryComplexities } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/hooks/directive/useMaintenanceDirectiveDiagnosticEntryComplexities'
import { DirectiveComplexityValidationSchema } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/schemas/maintenanceForwardingDirectiveSteps.schema'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'
import { MaintenanceForwardingsDirectiveFormStepProps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/maintenanceForwardingsDirectiveFormStep.type'
import { useFormContext, useWatch } from 'react-hook-form'

const DirectiveComplexityFormStepPending = ({
  state,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.DirectiveComplexity>) => {
  const { increaseStep } = useCreateForwardingsFormStore()

  const { control } = useFormContext<DirectiveComplexityValidationSchema>()

  const { complexity: watchComplexity } = useWatch({
    control,
  })

  const { data: complexitiesOptions } = useMaintenanceDirectiveDiagnosticEntryComplexities({
    mapper: Mapper.mapToOptions({
      valueFieldName: 'id',
      labelFieldName: 'display_name',
    }),
  })

  return (
    <CreateForwardingDirectiveEntryFormStepAccordion
      state={state}
      title="Complexidade do diagnóstico"
      body={
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="complexity"
            options={complexitiesOptions}
            label="Complexidade do diagnóstico"
            placeholder="Defina a complexidade do diagnóstico"
            operationKlassToCheckPermission="Client::Maintenance::Directive::DiagnosticEntryComplexities::Filter"
          />

          <div className="flex items-center justify-end">
            <div className="flex items-center gap-2">
              <Button disabled={!watchComplexity} onClick={increaseStep}>
                Confirmar
              </Button>
            </div>
          </div>
        </div>
      }
    />
  )
}

export default DirectiveComplexityFormStepPending
